"use client"

import React from "react"

import { Label } from "@/components/ui/components/label"

export function FormRow({
  label,
  htmlFor,
  required = false,
  children,
}: {
  label: string | undefined
  htmlFor: string
  required?: boolean
  children: React.ReactNode
}) {
  return (
    <div className="grid grid-cols-1 items-start gap-2 md:grid-cols-3 md:gap-8">
      <Label htmlFor={htmlFor} className="pt-2 text-sm font-medium md:text-right">
        {label}
        {required && <span className="ml-1 text-red-500">*</span>}
      </Label>
      <div className="md:col-span-2">{children}</div>
    </div>
  )
}
